import React, { PropsWithChildren, ReactNode } from 'react';
import styled from '@emotion/styled';
import { FormGrid, Tooltip } from '../../primitives';
import { Box, Button, IconButton, Tooltip as MuiTooltip } from '@mui/material';
import { Contact } from '../types';

export const AttributesWrapper = styled(FormGrid)`
  & .attribute-label {
    margin-top: 0.25rem;
    user-select: none;
  }

  row-gap: 0.75rem;

  & .form-control {
    & .MuiInputBase-root {
      margin-top: 0;
    }

    & .MuiAutocomplete-root {
    }
    & .MuiInputBase-root {
      &:before {
        opacity: 0.5;
      }
    }
  }
`;

export const DoNotContactBlip = () => {
  return (
    <Tooltip text="Не контактировать">
      <Box 
        sx={{ 
          width: 8, 
          height: 8, 
          borderRadius: '50%', 
          bgcolor: 'error.main',
          flexShrink: 0 // Prevents the dot from squishing on tight screens
        }} 
      />
    </Tooltip>
  )
}

interface ContactNameProps {
  contact: Contact;
}

export const ContactNameWithNotices = (props: ContactNameProps) => {
  const { contact } = props;
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <span>{`${contact.last_name} ${contact.first_name} ${contact.middle_name || ""}`}</span>
      
      {contact.do_not_contact &&
        <DoNotContactBlip />}
    </Box>
  )
}


interface SmallAddButtonProps {
  icon?: ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  iconOnly?: boolean;
}

export const SmallAddButton = (props: PropsWithChildren<SmallAddButtonProps>) => {
  if(props.iconOnly) {
    return (
      <MuiTooltip title={props.children}>
        <IconButton
          size="small" 
          onClick={e => props.onClick && props.onClick(e)}
          sx={{ 
            textTransform: 'none', 
            px: 0,
            fontSize: 0.5,
            color: 'text.secondary',
            '&:hover': { background: 'transparent' },
            '& svg': { fontSize: 18 },
          }}>
          {props.icon}
        </IconButton>
      </MuiTooltip>
    )
  }

  return (
    <Button 
      size="small" 
      startIcon={props.icon} 
      onClick={e => props.onClick && props.onClick(e)}
      sx={{ 
        textTransform: 'none', 
        px: 0, 
        color: 'text.secondary',
        '&:hover': { background: 'transparent', textDecoration: 'underline', textDecorationStyle: "dotted", textDecorationThickness: 0.5 },
        textUnderlineOffset: 3,
      }}
    >
      {props.children}
    </Button>
  )
}
